import { objectOf, arrayOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isProductAlertsResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      id: string,
      target: string,
      target_id: string,
      target_name: string,
      name: string,
      status: string,
      rules: objectOf({
        group_operator: string,
        condition_groups: arrayOf(
          objectOf({
            condition_operator: string,
            conditions: arrayOf(
              objectOf({
                metric: string,
                subject: string,
                operator: string,
                threshold_value: number,
              })
            ),
          })
        ),
      }),
      notification_channels: arrayOf(string),
    })
  ),
});
